<script setup>
import { computed, ref, onMounted, onUnmounted } from "vue";
import { storeToRefs } from "pinia";
import Button from "primevue/button";
import Card from "@/components/Card.vue";
import { useRecursosDidaticosStore } from "@/store/recursosDidaticosStore";
import { salvarQuestaoNaLista } from "@/api/fetchAvaliacoes";
import { copiarQuestaoParaAreaDeTransferencia } from "@/utils/copiarQuestaoParaAreaDeTransferencia";
import NadaEncontrado from '@/components/NadaEncontrado.vue';
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import GerenciarQuestao from "./GerenciarQuestao.vue";
import { replaceEspacosPorHTML } from "@/utils/replaceEspacosPorHTML";
//dasda
import { useGlobalToast } from '@/composables/useGlobalToast';
const { showToast } = useGlobalToast();


const store = useRecursosDidaticosStore();
const {  questoes, avaliacao, carregandoQuestoes } = storeToRefs(store);

async function  adicionarQuestaoNaAvaliacao(id) {
    let questaoJaexiste = avaliacao.value.questoes.find(questao => questao.questao === id);
    if (questaoJaexiste) {
        return
    }
    let data = await salvarQuestaoNaLista(avaliacao.value.id, id, avaliacao.value.questoes.length + 1);
    if(!data) return
    avaliacao.value.questoes.push({questao: data.questao, ordem: data.ordem});
}

const questaoJaAdicionadaNaAvaliacao = computed(() => (id) => {
    let questaoJaexiste = avaliacao.value.questoes.find(questao => questao.questao === id);
    if (questaoJaexiste) return true
    return false 
})

function copiarQuestao(questao){
    showToast({ severity: 'contrast', summary: 'Questão copiada', detail: questao.pergunta, life: 3000 })
    copiarQuestaoParaAreaDeTransferencia(questao)
}


const main = ref(null);

const checkScroll = () => {
    if (!main.value) return;
    const { scrollTop, scrollHeight, clientHeight } = main.value;
    if (scrollHeight - scrollTop <= clientHeight * 1.1) {
       store.carregarMaisQuestoes();
    }
};


onMounted(() => {
    main.value = document.getElementsByClassName('main-component')[0];
    main.value?.addEventListener('scroll', checkScroll);
});

onUnmounted(() => {
    main.value?.removeEventListener('scroll', checkScroll);
});

</script>
<template>
    <div class="flex flex-column gap-5 md:gap-5">
        <Card v-for="questao in questoes" :key="questao.id">
            <template #conteudo>
                <div class="flex flex-column gap-4">
                    <div class="flex justify-content-between align-items-center gap-4">
                        <div class="text-lg text-color-secondary">{{ questao.conceitos }}</div>
                        <GerenciarQuestao :questao="questao" :questaoId="questao.id" />
                    </div>
                    <img v-if="questao.imagem" :src="questao.imagem" class="w-full" />
                    <div class="text-base text-color" v-html="replaceEspacosPorHTML(questao.texto)"></div>
                    <div class="font-semibold text-color text-lg">{{ questao.pergunta }}</div>
                    <div v-if="questao.a" class="flex flex-column gap-4">
                        <div v-if="questao.a" class="flex flex-row gap-3 align-items-center">
                            <div class="font-semibold border-round-md p-2 surface-200 cursor-pointer text-center w-3rem"
                                :class="{ 'bg-primary-500 text-white': questao.gabarito === 'a' }">
                                A
                            </div>
                            <div class="w-full text-base text-color">
                                {{ questao.a }}
                            </div>
                        </div>
                        <div v-if="questao.b" class="flex flex-row gap-3 align-items-center">
                            <div class="font-semibold border-round-md p-2 surface-200 cursor-pointer text-center w-3rem"
                                :class="{ 'bg-primary-500 text-white': questao.gabarito === 'b' }">
                                B
                            </div>
                            <div class="w-full text-base text-color">
                                {{ questao.b }}
                            </div>
                        </div>
                        <div v-if="questao.c" class="flex flex-row gap-3 align-items-center">
                            <div class="font-semibold border-round-md p-2 surface-200 cursor-pointer text-center w-3rem"
                                :class="{ 'bg-primary-500 text-white': questao.gabarito === 'c' }">
                                C
                            </div>
                            <div class="w-full text-base text-color">
                                {{ questao.c }}
                            </div>
                        </div>
                        <div v-if="questao.d" class="flex flex-row gap-3 align-items-center">
                            <div class="font-semibold border-round-md p-2 surface-200 cursor-pointer text-center w-3rem"
                                :class="{ 'bg-primary-500 text-white': questao.gabarito === 'd' }">
                                D
                            </div>
                            <div class="w-full text-base text-color">
                                {{ questao.d }}
                            </div>
                        </div>
                        <div v-if="questao.e" class="flex flex-row gap-3 align-items-center">
                            <div class="font-semibold border-round-md p-2 surface-200 cursor-pointer text-center w-3rem"
                                :class="{ 'bg-primary-500 text-white': questao.gabarito === 'e' }">
                                E
                            </div>
                            <div class="w-full text-base text-color">
                                {{ questao.e }}
                            </div>
                        </div>
                    </div>
                    <div class="flex justify-content-end gap-2 mt-5">
                        <Button v-tooltip.top="'Adicionar na avaliação selecionada'"
                            :label="!questaoJaAdicionadaNaAvaliacao(questao.id) ? 'Adicionar' : 'Adicionado'"
                            :icon="!!questaoJaAdicionadaNaAvaliacao(questao.id) ? 'pi pi-check' : 'pi pi-plus'"
                            severity="secondary" text
                            v-if="avaliacao.id !== null && avaliacao.adicionarQuestoes === true"
                            @click="adicionarQuestaoNaAvaliacao(questao.id)" />
                        <Button label=" Copiar" icon="pi pi-copy" severity="secondary" text
                            @click="copiarQuestao(questao)" />
                    </div>
                </div>
            </template>
        </Card>
        <NadaEncontrado v-if="!carregandoQuestoes && questoes.length === 0"
            mensagem="Não encontramos nenhuma questão" />
        <LoadingSpinner v-if="carregandoQuestoes" />

    </div>
</template>